module.exports = __webpack_public_path__ + "assets/images/pages/unleash/ball-3.png?1637f3b3";